import styled from '@emotion/styled'

export const ImportedInvoiceReviewFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`
